import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { AgePipe, CurrencyCustomPipe, StatusPipe } from './pipes';
import { FORMATS_CONFIGURATION_TOKEN, FormatConfiguration } from './tokens';
import { CountryPipe } from './pipes/country.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [AgePipe, CurrencyCustomPipe, StatusPipe, CountryPipe],
  exports: [AgePipe, CurrencyCustomPipe, StatusPipe, CountryPipe],
  providers: [CurrencyPipe]
})
export class SharedUtilFormattingModule {
  static forRoot(configuration: FormatConfiguration): ModuleWithProviders {
    return {
      ngModule: SharedUtilFormattingModule,
      providers: [
        {
          provide: FORMATS_CONFIGURATION_TOKEN,
          useValue: configuration
        }
      ]
    };
  }
}
